import { Button } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

const Departure = ({
  arrivalTime = '',
  arrivalDescription = '',
  departureTime = '',
  departureDescription = '',
  isBoarding = false,
  isLoading = false,
  buttonHref = '',
  buttonText = 'Book',
}) => (
  <div className="departure d-flex py-2">
    <div className="d-flex flex-row">
      <div className="d-flex flex-column justify-content-center align-items-center me-3">
        <i className="fas fa-circle text-white text-xxx-small" />
        <div className="departure__line" />
        <i className="far fa-circle text-white text-xxx-small" />
      </div>
      <div>
        <div className="mb-2">
          <div className="text-large fw-bold text-white">
            {isLoading ? <Skeleton width="4rem" /> : departureTime}
          </div>
          <div className="text-x-small text-white">
            {isLoading ? <Skeleton width="5rem" /> : departureDescription}
          </div>
        </div>
        <div>
          <div className="text-large fw-bold text-white">
            {isLoading ? <Skeleton width="4rem" /> : arrivalTime}
          </div>
          <div className="text-x-small text-white">
            {isLoading ? <Skeleton width="5rem" /> : arrivalDescription}
          </div>
        </div>
      </div>
    </div>
    <div className="d-flex align-items-center justify-content-center ms-auto ms-lg-5">
      {isLoading && <Skeleton width="4rem" height="2rem" />}
      {!isLoading && isBoarding && (
        <div className="d-flex flex-column align-items-center text-accent">
          <i className="far fa-clock text-xx-large" />
          <p className="fw-bold text-nowrap">Now boarding</p>
        </div>
      )}
      {!isLoading && !isBoarding && !isEmpty(buttonText) && (
        <Button
          className="btn btn-accent text-white"
          href={buttonHref}
          data-ga-event="add_ferry_to_booking"
        >
          {buttonText}
        </Button>
      )}
    </div>
  </div>
);

Departure.propTypes = {
  arrivalTime: PropTypes.string,
  arrivalDescription: PropTypes.string,
  departureTime: PropTypes.string,
  departureDescription: PropTypes.string,
  isLoading: PropTypes.bool,
  isBoarding: PropTypes.bool,
  buttonHref: PropTypes.string,
  buttonText: PropTypes.string,
};

export default Departure;
